// mostly from savant-central-management's Host component
import { makePublicUrl } from 'app/utils/publicUrl'

export const DefaultHostSvg = makePublicUrl(
  'images/hostIcons/savant-pro-app.svg'
)
const SmartHostSvg = makePublicUrl('images/hostIcons/smart-host.svg')
const MacHostSvg = makePublicUrl('images/hostIcons/pro-host.svg')
const SuperProSvg = makePublicUrl('images/hostIcons/super-pro-host.svg')
const Sipa1smSvg = makePublicUrl('images/hostIcons/HST-SIPA1SM.svg')
const MarleySvg = makePublicUrl('images/hostIcons/HST-STUDIO55WS-SUR.svg')
const ClaptonSvg = makePublicUrl('images/hostIcons/HST-STUDIO.svg')
const ShrS2Svg = makePublicUrl('images/hostIcons/SHR-S2-00.svg')
const ShrSmartSvg = makePublicUrl('images/hostIcons/SHR-2000-00.svg')
const Svr7100 = makePublicUrl('images/hostIcons/svr-7100s.svg')
const HostDirSvg = makePublicUrl('images/hostIcons/HST-Director.svg')
const HostDirLiteSvg = makePublicUrl('images/hostIcons/HST-DirectorLite.svg')
const HostDirCSvg = makePublicUrl('images/hostIcons/HST-Director-C.svg')
const MacStudioSvg = makePublicUrl('images/hostIcons/studio-host.svg')
const HostDir01Svg = makePublicUrl('images/hostIcons/PB-P2000-00.svg')
const UnknownMacSvg = makePublicUrl('images/hostIcons/mac-host.svg')
const MacHost5400Svg = makePublicUrl('images/hostIcons/m4_mac.svg')
const KeyPadHostSvg = makePublicUrl('images/hostIcons/kph.svg')


export const hostImageByProfileModel: Record<string, string> = {
  'Super Pro Host v2': Svr7100,
}

export const hostImageByType: Record<string, string> = {
  Mac: MacHostSvg,
  'Mac-Super': SuperProSvg,
  Linux: DefaultHostSvg,
  'Linux-ARM-Ace': SmartHostSvg,
  'Linux-ARM-SimplePro': SmartHostSvg,
  'Linux-ARM-Clapton': ClaptonSvg,
  'Linux-ARM-38Special': Sipa1smSvg,
  'Linux-ARM-Marley': MarleySvg,
  'Linux-ARM-SHR': ShrSmartSvg,
  'Linux-Director': HostDirSvg,
  'Linux-Director-Lite': HostDirLiteSvg,
  'Mac-Studio': MacStudioSvg,
}

export const hostImageByEnum: string[] = [
  MacHostSvg, // 0 // RPMUTILS_HOSTTYPE_MAC=0
  DefaultHostSvg, // 1 // RPMUTILS_HOSTTYPE_SMARTHOST_DEEPCANYON
  DefaultHostSvg, // 2 // RPMUTILS_HOSTTYPE_SMARTHOST_THINCANYON
  SmartHostSvg, // 3 // RPMUTILS_HOSTTYPE_SMARTHOST_ACE
  SmartHostSvg, // 4 // RPMUTILS_HOSTTYPE_SIMPLEHOST
  SmartHostSvg, // 5 // RPMUTILS_HOSTTYPE_SIMPLEHOSTPRO
  SmartHostSvg, // 6 // RPMUTILS_HOSTTYPE_S2HOST
  SuperProSvg, // 7 // RPMUTILS_HOSTTYPE_MAC_SUPER
  ClaptonSvg, // 8 // RPMUTILS_HOSTTYPE_CLAPTON_HOST
  Sipa1smSvg, // 9 // RPMUTILS_HOSTTYPE_ASTLEY_HOST
  DefaultHostSvg, // 10 // RPMUTILS_HOSTTYPE_GWHOSTPRO
  DefaultHostSvg, // 11 // RPMUTILS_HOSTTYPE_TSTATHOSTPRO,
  MarleySvg, // 12 // RPMUTILS_HOSTTYPE_MARLEY_HOST
  ShrS2Svg, // 13 // RPMUTILS_HOSTTYPE_S2SM_HOST
  ShrSmartSvg, // 14 // RPMUTILS_HOSTTYPE_SHR2000_HOST
  HostDirSvg, // 15 // RPMUTILS_HOSTTYPE_DIRECTOR
  HostDirLiteSvg, // 16 // RPMUTILS_HOSTTYPE_DIRECTOR_LITE
  DefaultHostSvg, // 17 // RPMUTILS_HOSTTYPE_DIRECTOR_PLUS
  HostDirCSvg, // 18 // RPMUTILS_HOSTTYPE_DIRECTORC
  DefaultHostSvg, // 19 // RPMUTILS_HOSTTYPE_DIRECTOR_LITEC
  DefaultHostSvg, // 20 // RPMUTILS_HOSTTYPE_UNKNOWN
  UnknownMacSvg, // 21 RPMUTILS_HOSTTYPE_STUDIO_UNSUPPORTED, Unsupported Mac Studio M1 variants
  MacHostSvg, // 22 RPMUTILS_HOSTTYPE_MAC_EVO, EVO Supported Mac Mini (M2+) (instead of RPMUTILS_HOSTTYPE_MAC)
  MacHostSvg, // 23 RPMUTILS_HOSTTYPE_MACMINIPRO_EVO, EVO Supported Mac Mini Pro (M2 Pro+) (instead of RPMUTILS_HOSTTYPE_MAC)
  Svr7100, // 24 RPMUTILS_HOSTTYPE_MAC_SUPER_EVO, EVO Supported Mac Super Pro (M2+) (instead of RPMUTILS_HOSTTYPE_MAC_SUPER)
  MacStudioSvg, // 25 RPMUTILS_HOSTTYPE_STUDIOMAXM2, Mac Studio M2 Max
  MacStudioSvg, // 26 RPMUTILS_HOSTTYPE_STUDIOULTRAM2, Mac Studio M2 Ultra
  MarleySvg, // 27 RPMUTILS_HOSTTYPE_MARLEY_ECO, EVO Supported HST-STUDIO55WS-SUR
  Sipa1smSvg, // 28 RPMUTILS_HOSTTYPE_ASTLEY_ECO, EVO Supported HST-SIPA1ECO-00
  DefaultHostSvg, // 29 RPMUTILS_HOSTTYPE_DIRECTOR_PLUSC, HST-DIR DirectorPlusC,
  KeyPadHostSvg, // 30 RPMUTILS_HOSTTYPE_KEYPAD, HST-KEY Keypad,
  HostDir01Svg, // 31 RPMUTILS_HOSTTYPE_DIRECTOR1, HST-DIR Director-01,
  HostDir01Svg, // 32 RPMUTILS_HOSTTYPE_DIRECTORC1, HST-DIR DirectorC-01,
  MarleySvg, // 33 RPMUTILS_HOSTTYPE_WAILERS,
  MarleySvg, // 34 RPMUTILS_HOSTTYPE_WAILERS_ECO,
  DefaultHostSvg, // 35 RPMUTILS_HOSTTYPE_DIRECTOR_SAGE, HST-DIRECTOR-SAGE,
  MacHost5400Svg, // 36 RPMUTILS_HOSTTYPE_MACMINIPRO_EVO, EVO Supported Mac Mini Pro 
  DefaultHostSvg, // 37 RPMUTILS_HOSTTYPE_DIRECTOR_SAGE, HST-DIRECTOR-SAGE,
  MacStudioSvg, // 38 RPMUTILS_HOSTTYPE_STUDIOULTRAM3
  MacStudioSvg, // 39 RPMUTILS_HOSTTYPE_STUDIOMAXM4
  DefaultHostSvg, // 40 RPMUTILS_HOSTTYPE_DESKTOP
  DefaultHostSvg, // 41 RPMUTILS_HOSTTYPE_DIRECTOR_SAGE_SM
  DefaultHostSvg, // 42 RPMUTILS_HOSTTYPE_PS20
]
